export default __webpack_public_path__ + "static/media/settings-gear.ec5d1bfb.svg";